@if (lesson | async; as lesson) {
  <ng-container class="lesson">
    <header class="lesson-header">
      <div>
        <h1>Identification, Strategy and Hypothesis</h1>
        <p>{{lesson.topicIdentificationCopy}}</p>
      </div>
    </header>
    <section class="lesson-content">
      <div class="lesson-problem">
        @if (lesson.problem.content) {
          <app-content-viewer [content]=lesson.problem.content></app-content-viewer>
        }
        @if (utilitiesService.problemHasContentPassage(lesson.problem)) {
          <div class="lesson-passage" >
            <app-content-viewer [content]=lesson.problem.passage.content></app-content-viewer>
          </div>
        }
      </div>
      <div class="lesson-answers">
        @if (topics | async; as topics) {
          <app-multi-choice [options]="topics"
            [displayField]="'displayName'"
            [title]="lesson.topicIdentificationPrompt"
            [correctTitle]="lesson.topicIdentificationCorrectCopy"
            [incorrectTitle]="lesson.topicIdentificationIncorrectCopy"
            [idField]="'id'" (optionSelected)="handleSelectedTopic($event, lesson)">
          </app-multi-choice>
        } @else {
          <app-spinner></app-spinner>
        }
        @if (readyToContinue) {
          <a class="btn btn-lg btn-block btn-primary" [routerLink]="['../strategy-identification']">
            Next
          </a>
        }
      </div>
    </section>
  </ng-container>
} @else {
  <app-spinner></app-spinner>
}

